import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { IOperator } from '@/api/routes/operators/types';
import smartSort from '@/utils/smartSort';

import { fetchOperators } from './actionCreators';

interface InitialState {
  operators: IOperator [],
  isLoading: boolean,
  error: string,
}

const initialState: InitialState = {
  operators: [],
  isLoading: false,
  error: '',
};

export const operatorsSlice = createSlice({
  name: 'operators',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchOperators.fulfilled.type]: (state, action: PayloadAction<IOperator []>) => {
      state.isLoading = false;
      state.error = '';
      state.operators = action.payload.sort((a, b) => smartSort(a.name, b.name));
    },
    [fetchOperators.pending.type]: (state) => {
      state.isLoading = true;
    },
    [fetchOperators.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export default operatorsSlice.reducer;
